import http from '@services/http'
import { ISignin, ILogout, IAdultAuthenticationExpire, INaverMemberProfile } from '@protocol/auth'

export default {
  login(data: ISignin.Params): Promise<ISignin.Schema> {
    return http.post('auth/signin', data || {})
  },

  loginByGoogle(data: ISignin.SocialLoginParams): Promise<ISignin.Schema> {
    return http.post('auth/signin_by_google', data || {})
  },

  loginByKakao(data: ISignin.SocialLoginParams): Promise<ISignin.Schema> {
    return http.post('auth/signin_by_kakao', data || {})
  },

  loginByNaver(data: ISignin.SocialLoginParams): Promise<ISignin.Schema> {
    return http.post('auth/signin_by_naver', data || {})
  },

  loginByApple(data: ISignin.SocialLoginParams): Promise<ISignin.Schema> {
    return http.post('auth/signin_by_apple', data || {})
  },

  loginByAuthKey(data: ISignin.loginByAuthKey): Promise<ISignin.Schema> {
    return http.post('auth/signin_by_auth_key', data || {})
  },

  logout(data: ILogout.Params): Promise<ILogout.Schema> {
    return http.get('auth/logout', data || {})
  },

  checkAdultAuthenticationExpire(data: IAdultAuthenticationExpire.Params): Promise<IAdultAuthenticationExpire.Schema> {
    return http.post('auth/checkAdultAuthenticationExpire', data || {})
  },

  getNaverMemberProfile(data: INaverMemberProfile.Params): Promise<INaverMemberProfile.Schema> {
    return http.post('auth/getNaverMemberProfile', data || {})
  },
}
